import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-question",
  "use": "icon-question-usage",
  "viewBox": "0 0 48.2 48.1",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 48.2 48.1\" id=\"icon-question\">\n<path d=\"M34.2,2.3c0.7,0.3,1.1,0.9,1.1,1.6c0.1,0.7-0.3,1.4-0.8,1.8c-0.6,0.4-1.3,0.5-2,0.2C29.9,4.7,27,4,24.1,4c-11,0-20,9-20,20\n\ts9,20,20,20s20-9,20-20c0-5.1-1.9-9.9-5.4-13.6c-0.7-0.8-0.7-2.1,0.1-2.8c0.8-0.7,2-0.7,2.8,0.1c4.1,4.4,6.4,10.3,6.4,16.3\n\tc0,13.3-10.7,24-24,24s-24-10.7-24-24s10.7-24,24-24C27.6,0,31,0.8,34.2,2.3z\" />\n<path d=\"M21.6,35c0,0.9,0.5,1.7,1.2,2.1c0.7,0.4,1.7,0.4,2.4,0c0.7-0.4,1.2-1.2,1.2-2.1c0-1.3-1.1-2.4-2.4-2.4\n\tC22.7,32.6,21.6,33.7,21.6,35z M28.3,20c0.2-2-0.8-4-3.8-4c-3.2,0-4.4,1.9-4.4,4.4c0,1.1-0.9,2-2,2c-1.1,0-2-0.9-2-2\n\tc0-4.5,2.5-8.4,8.4-8.4c3.3,0,5.6,1.5,6.8,3.9c0.8,1.5,1,3.3,0.9,4.5c-0.2,2.1-0.8,3.6-2.6,5c-0.2,0.1-2.8,2-3.2,2.3\n\tc-0.4,0.4-0.5,0.6-0.5,1.2c0,1.1-0.9,2-2,2c-1.1,0-2-0.9-2-2c0-1.7,0.6-3,1.8-4.1c0.6-0.6,3.5-2.6,3.4-2.6\n\tC27.9,21.7,28.2,21.1,28.3,20z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/question.svg
// module id = noTa
// module chunks = 59